import React from "react";

const AvisoLegal = () => (
  <div className="document-container">
    <div className="aviso-legal">
      <h1>Aviso Legal</h1>
      <h2>Información General</h2>
      <p>
        En cumplimiento con la Ley 34/2002, de 11 de julio, de Servicios de la
        Sociedad de la Información y Comercio Electrónico (LSSI-CE), se informa
        que el titular del sitio web es CONESA SOCIAL MEDIA, con CIF [CIF] y domicilio C/Bruselas, 4 - EuroRoda (San Javier) Murcia.
      </p>
      <h2>Condiciones de Uso</h2>
      <p>
        El acceso y uso de este sitio web atribuyen la condición de usuario e
        implican la aceptación plena de las condiciones de uso vigentes en cada
        momento. Los usuarios se comprometen a utilizar los contenidos del sitio
        de forma adecuada, evitando actividades ilícitas, que vulneren derechos
        o normas de protección de datos.
      </p>
      <h2>Propiedad Intelectual</h2>
      <p>
        Todos los contenidos, textos, imágenes, y código fuente del sitio están
        protegidos por derechos de propiedad intelectual e industrial. Queda
        prohibida la reproducción, distribución, y comunicación pública de la
        totalidad o parte de los contenidos de este sitio web sin la
        autorización expresa de CONESA SOCIAL MEDIA.
      </p>
      <h2>Exclusión de Responsabilidad</h2>
      <p>
        CONESA SOCIAL MEDIA no se responsabiliza de los daños o perjuicios derivados del
        acceso, uso o interpretación de la información contenida en este sitio
        web. Tampoco se hace responsable del contenido de los enlaces externos
        que puedan incluirse.
      </p>
      <h2>Legislación Aplicable</h2>
      <p>
        El presente Aviso Legal se rige en todos sus extremos por la legislación
        española. Cualquier conflicto será resuelto ante los tribunales del
        domicilio del titular del sitio web.
      </p>
    </div>
  </div>
);

export default AvisoLegal;
